<template>
  <div class="partner-area pt-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-12">
          <div class="partner-title">
            Tecnologias que utilizamos:
          </div>
        </div>
        <div class="col-lg-8 col-md-12">
          <div class="partner-item-lists">
            <div class="row align-items-center">
              <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="partner-item">
                  <img src="../../assets/images/partner/partner1.png" alt="Vue.js - Framework JavaScript para desenvolvimento frontend">
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="partner-item">
                  <img src="../../assets/images/partner/partner2.png" alt="React - Biblioteca JavaScript para interfaces de usuário">
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="partner-item">
                  <img src="../../assets/images/partner/partner5.png" alt="Laravel - Framework PHP para desenvolvimento backend">
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-6">
                <div class="partner-item">
                  <img src="../../assets/images/partner/partner4.png" alt="Node.js - Ambiente de execução JavaScript server-side">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partner'
}
</script>